module.exports = __webpack_public_path__ + "img/classen_logo.ed78022d.jpg";